module.exports = __webpack_public_path__ + "static/media/eforia.ff75f7f8.png";